import { ExauthState, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Exam Auth State|`;

type SharedKeys = Pick<
	LocDef,
	'type' | 'portal' | 'displayType' | 'htmlAllowed' | 'portal' | 'shared' | 'feature'
>;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: true,
	feature: HubFeature.ExamAuthorization,
};

const sharedSpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'SP',
};

const sharedCpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'CP',
};

export type SPExauthStateLocs = `SPExauthStateEnum${ExauthState}`;

export const spExauthStateEnumLocs: LocDefs<SPExauthStateLocs> = {
	SPExauthStateEnumComplete: {
		defaultValue: 'Complete',
		displayPath: `${dpRoot}${ExauthState.Complete}`,
		description: `System value for '${ExauthState.Complete}' exam authorization state`,
		...sharedSpLocData,
	},
	SPExauthStateEnumError: {
		defaultValue: 'Error',
		displayPath: `${dpRoot}${ExauthState.Error}`,
		description: `System value for '${ExauthState.Error}' exam authorization state`,
		...sharedSpLocData,
	},
	SPExauthStateEnumRejected: {
		defaultValue: 'Rejected',
		displayPath: `${dpRoot}${ExauthState.Rejected}`,
		description: `System value for '${ExauthState.Rejected}' exam authorization state`,
		...sharedSpLocData,
	},
	SPExauthStateEnumQueued: {
		defaultValue: 'Queued',
		displayPath: `${dpRoot}${ExauthState.Queued}`,
		description: `System value for '${ExauthState.Queued}' exam authorization state`,
		...sharedSpLocData,
	},
	SPExauthStateEnumRequested: {
		defaultValue: 'Requested',
		displayPath: `${dpRoot}${ExauthState.Requested}`,
		description: `System value for '${ExauthState.Requested}' exam authorization state`,
		...sharedSpLocData,
	},
};

export type CPExauthStateLocs = `CPExauthStateEnum${ExauthState}`;

export const cpExauthStateEnumLocs: LocDefs<CPExauthStateLocs> = {
	CPExauthStateEnumComplete: {
		defaultValue: 'Complete',
		displayPath: `${dpRoot}${ExauthState.Complete}`,
		description: `System value for '${ExauthState.Complete}' exam authorization state`,
		...sharedCpLocData,
	},
	CPExauthStateEnumError: {
		defaultValue: 'Error',
		displayPath: `${dpRoot}${ExauthState.Error}`,
		description: `System value for '${ExauthState.Error}' exam authorization state`,
		...sharedCpLocData,
	},
	CPExauthStateEnumRejected: {
		defaultValue: 'Rejected',
		displayPath: `${dpRoot}${ExauthState.Rejected}`,
		description: `System value for '${ExauthState.Rejected}' exam authorization state`,
		...sharedCpLocData,
	},
	CPExauthStateEnumQueued: {
		defaultValue: 'Queued',
		displayPath: `${dpRoot}${ExauthState.Queued}`,
		description: `System value for '${ExauthState.Queued}' exam authorization state`,
		...sharedCpLocData,
	},
	CPExauthStateEnumRequested: {
		defaultValue: 'Requested',
		displayPath: `${dpRoot}${ExauthState.Requested}`,
		description: `System value for '${ExauthState.Requested}' exam authorization state`,
		...sharedCpLocData,
	},
};

export const EX_AUTH_STATE_ENUM_LOCS = MapLocKeys<SPExauthStateLocs | CPExauthStateLocs>({
	...spExauthStateEnumLocs,
	...cpExauthStateEnumLocs,
});

export type SPExauthStateEnumLocType = LocMap<SPExauthStateLocs>;
export type CPExauthStateEnumLocType = LocMap<CPExauthStateLocs>;

export const spExauthStateKeys: {
	[key in ExauthState]: keyof SPExauthStateEnumLocType;
} = {
	[ExauthState.Complete]: EX_AUTH_STATE_ENUM_LOCS.SPExauthStateEnumComplete,
	[ExauthState.Error]: EX_AUTH_STATE_ENUM_LOCS.SPExauthStateEnumError,
	[ExauthState.Rejected]: EX_AUTH_STATE_ENUM_LOCS.SPExauthStateEnumRejected,
	[ExauthState.Queued]: EX_AUTH_STATE_ENUM_LOCS.SPExauthStateEnumQueued,
	[ExauthState.Requested]: EX_AUTH_STATE_ENUM_LOCS.SPExauthStateEnumRequested,
};

export const cpExauthStateKeys: {
	[key in ExauthState]: keyof CPExauthStateEnumLocType;
} = {
	[ExauthState.Complete]: EX_AUTH_STATE_ENUM_LOCS.CPExauthStateEnumComplete,
	[ExauthState.Error]: EX_AUTH_STATE_ENUM_LOCS.CPExauthStateEnumError,
	[ExauthState.Rejected]: EX_AUTH_STATE_ENUM_LOCS.CPExauthStateEnumRejected,
	[ExauthState.Queued]: EX_AUTH_STATE_ENUM_LOCS.CPExauthStateEnumQueued,
	[ExauthState.Requested]: EX_AUTH_STATE_ENUM_LOCS.CPExauthStateEnumRequested,
};
